// extracted by mini-css-extract-plugin
export default {"section-mobile":"Mobile_section-mobile__ZDnex"};